// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26CI5","colMin":"styles_colMin__1Becz"};